import { render, staticRenderFns } from "./LayoutSplit.vue?vue&type=template&id=53357938&scoped=true&"
import script from "./LayoutSplit.vue?vue&type=script&lang=js&"
export * from "./LayoutSplit.vue?vue&type=script&lang=js&"
import style0 from "./LayoutSplit.vue?vue&type=style&index=0&id=53357938&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53357938",
  null
  
)

export default component.exports